import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { formattedLongDate } from "../../common-data/Converts";
import CampaignForm from "./CampaignForm";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { campaignSystemDelete } from "../../../data/ApiEndpoints";
import { GreenCheckIcon } from "../../../images/icons/icons";

const CampaignLogs = ({
  userInfoData,
  isLoading,
  tbDatas,
  isPage,
  setIsPage,
  callFunction,
}) => {
  const dispatch = useDispatch();

  const iniModValues = {
    isModalOpen: false,
    cardType: "",
    viewImage: "",
    rowData: {},
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: campaignSystemDelete,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "Feature is deleted successfully!"
            );
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete Feature!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete Feature");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete this Feature!`
      );
    } else {
      toast.error("UID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "campaign_name",
      text: "campaign name/ID",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.campaign_name?.replace(/_/g, " ") || "NA"}
            <br />
            <small className="underline gray">{row?.campaign_id || "-"}</small>
          </span>
        );
      },
    },
    {
      dataField: "panel_type",
      text: "panel type",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.panel_type === "panel_1"
              ? "Main"
              : row?.panel_type === "panel_2"
              ? "IVR"
              : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "campaign_type",
      text: "campaign type",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.campaign_type === "1"
              ? "P2P"
              : row?.campaign_type === "2"
              ? "IVR"
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "wp_template_connected",
      text: "template connected",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.wp_template_connected?.replace(/_/g, " ") || "-"}
          </span>
        );
      },
    },
    {
      dataField: "wp_template_missed",
      text: "template missed",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.wp_template_missed?.replace(/_/g, " ") || "-"}
          </span>
        );
      },
    },
    {
      dataField: "wp_template_connected_agent_missed",
      text: "agent missed",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.wp_template_connected_agent_missed?.replace(/_/g, " ") ||
              "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "wp_tempate_connected_user_missed",
    //   text: "user missed",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.wp_tempate_connected_user_missed?.replace(/_/g, " ") || "NA"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "trigger_on_connected",
      text: "trigger on connected",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.trigger_on_connected === "true" ? <GreenCheckIcon /> : "-"}
          </span>
        );
      },
    },
    {
      dataField: "trigger_on_missed",
      text: "trigger on missed",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.trigger_on_missed === "true" ? <GreenCheckIcon /> : "-"}
          </span>
        );
      },
    },
    {
      dataField: "trigger_on_connected_agent_missed",
      text: "trigger on agent missed",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.trigger_on_connected_agent_missed === "true" ? (
              <GreenCheckIcon />
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className={`actionBtn icon edit`}
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModalOpen: true,
                cardType: "edit",
                rowData: row,
              }));
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
              style={{
                color: "#c71010",
                cursor: "pointer",
              }}
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            type="button"
            className={`actionBtn icon delete`}
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-trash3-fill"
              viewBox="0 0 16 16"
              style={{
                color: "#c71010",
                cursor: "pointer",
              }}
            >
              <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardType === "view_image"
              ? "discussionModalBriefContainer"
              : "mod-width-70p mod-height-95vh"
          }`}
          style={{
            height: modValues.cardType === "view_image" ? "auto" : "",
          }}
        >
          <ModalHeadAndClose
            title={
              modValues.cardType === "edit"
                ? "Update Campaign Detail"
                : modValues.cardType?.replace(/_/g, " ")
            }
            onClose={closeModal}
          />

          {modValues.cardType === "view_image" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.viewImage}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.cardType === "edit" ? (
            <CampaignForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={callFunction}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      {isLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="overflowAuto separatedTable mt15">
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={setIsPage}
          />
        </div>
      )}
    </>
  );
};

export default CampaignLogs;
